import { render, staticRenderFns } from "./Amigos.vue?vue&type=template&id=f9f9867e"
import script from "./Amigos.vue?vue&type=script&lang=js"
export * from "./Amigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports